import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { CoreTranslationService } from "@core/services/translation.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { ApiService } from "app/main/services/Api/api.service";
import { ToastService } from "app/main/services/Toast/toast.service";

@Component({
  selector: "app-organizer-event-schedule-check-in-and-check-out",
  templateUrl:
    "./organizer-event-schedule-check-in-and-check-out.component.html",
  styleUrls: [
    "./organizer-event-schedule-check-in-and-check-out.component.scss",
  ],
})
export class OrganizerEventScheduleCheckInAndCheckOutComponent implements OnInit {
  public contentHeader: object;
  eventCats: any;
  eventOrganizerCheckStatistics: FormGroup;

  /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(
    private _coreTranslationService: CoreTranslationService,
    private modalService: NgbModal,
    private api: ApiService,
    public toastService: ToastService,
    private formBuilder: FormBuilder,
  ) {
    this.eventOrganizerCheckStatistics = this.formBuilder.group({
      OrganizerNameEn: [""],
      OrganizerNameAr: [""],
      EventNameEn: [""],
      EventNameAr: [""],
      EventScheduleStartTime: [""],
      EventScheduleEndTime: [""],
      CheckInAt: [""],
      CheckOutAt: [""],
    });
    // this._coreTranslationService.translate(en, fr, de, pt)
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  ngOnInit() {
    document.getElementById("الرئيسية")?.classList.remove("active");
    document.getElementById("الفعاليات")?.classList.remove("active");
    document.getElementById("المشرفين")?.classList.remove("active");
    document.getElementById("المستخدمين")?.classList.remove("active");
    document.getElementById("طلبات المشرفين")?.classList.remove("active");
    document.getElementById("العروض")?.classList.remove("active");
    document.getElementById("المسئولين")?.classList.remove("active");

    this.columns = [
      {
        prop: "selected",
        name: "",
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50,
      },
      { prop: "#" },
      { prop: "OrganizerNameEn", name: "اسم المشرف بالانجليية" },
      { prop: "OrganizerNameAr", name: "اسم المشرف بالعربيه" },
      { prop: "EventNameEn", name: "اسم الفعاليه بالانجليزيه" },
      { prop: "EventNameAr", name: "اسم الفعاليه بالعربيه" },
      { prop: "EventScheduleStartTime", name: "تاريخ بدايه الفعاليه" },
      { prop: "EventScheduleEndTime", name: "تاريخ نهايه الفعاليه" },
      { prop: "CheckInAt", name: "تاريخ تسجيل الدخول" },
      { prop: "CheckOutAt", name: "تاريخ تسجيل الخروج" },
      { prop: "image", name: "الأيكونة" },
      { prop: "" },
    ];
    this.api.showOrganizerEventScheduleStatistics(1, 100).subscribe({
      next: (response) => {
        console.log(response.data);
        // Map API response to match the table structure
        this.rows = response.data.map((item, index) => ({
          id: item.id,
          "#": index + 1, // Assign a sequential number
          OrganizerNameEn: item.organizerNameEn,
          OrganizerNameAr: item.organizerNameAr,
          EventNameEn: item.eventNameEn,
          EventNameAr: item.eventNameAr,
          EventScheduleStartTime: this.formatEgyptDateTime(
            item.eventScheduleStartTime,
          ),
          EventScheduleEndTime: this.formatEgyptDateTime(
            item.eventScheduleEndTime,
          ),
          CheckInAt: this.formatEgyptDateTime(item.checkInAt),
          CheckOutAt:
            item.checkOutAt == null
              ? "لم يتم تسجيل الخروج بعد"
              : this.formatEgyptDateTime(item.checkOutAt),
        }));

        this.temp = [...this.rows]; // Store original data
      },
      error: (error: HttpErrorResponse) => {
        console.error("Error fetching event categories:", error);
      },
    });
    this.temp = this.rows;

    this.contentHeader = {
      headerTitle: "تسجيل دخول و خروج المشرفين",
      actionButton: false,
    };
  }
  formatEgyptDateTime(utcDate: string | Date): string {
    const date = new Date(utcDate);

    // التاريخ (dd/mm/yyyy)
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    // الوقت AM/PM
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}/${month}/${year} - ${hours}:${minutes} ${ampm}`;
  }

  // table
  public readonly pageLimitOptions = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 100 },
  ];
  public chkBoxSelected = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  // ColumnMode = ColumnMode;
  columns = [];
  customChkboxOnSelect({ selected }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : "";

    // Filter data by checking all columns
    const temp = this.temp.filter((row) => {
      return Object.keys(row).some((key) =>
        row[key]?.toString().toLowerCase().includes(val),
      );
    });

    // Update the rows
    this.rows = temp;
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor(
          (this.table.rowCount - 1) / this.table.limit,
        );
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }

  // modal
  modalOpenDefault(modalDefault) {
    this.modalService.open(modalDefault, {
      centered: true,
    });
  }
  modalOpenLG(modalLG) {
    this.modalService.open(modalLG, {
      centered: true,
      size: "lg",
    });
  }
  deletedItemId: any;
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }

  confirmDelete() {
    if (this.deletedItemId) {
      this.api.deleteEventCategory(this.deletedItemId).subscribe({
        next: (response) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم الحذف بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show("خطأ أثناء الحذف ❌");
        },
      });
    }
  }

  // upload image functions
  previewUrl1: string | ArrayBuffer | null = null;
  previewUrl2: string | ArrayBuffer | null = null;
  onFileSelected(event: Event, type: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        if (type === "iconEvent") {
          this.previewUrl1 = reader.result; // Set preview for first upload
        } else if (type == "iconEvent2") {
          this.previewUrl2 = reader.result;
        }
      };
      reader.readAsDataURL(file);
      this.eventOrganizerCheckStatistics.patchValue({
        image: file,
      });
      console.log(this.eventOrganizerCheckStatistics.get("image").value);
    }
  }

  // download files
  downloadFile(file: string) {
    if (file == "pdf") {
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير فئات الفعاليات</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0])
                    .map((header) => `<th>${header}</th>`)
                    .join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows
                  .map(
                    (row) => `
                  <tr>
                    ${Object.keys(row)
                      .map(
                        (key) =>
                          `<td>${row[key].toString().replace(/<[^>]*>/g, "")}</td>`,
                      )
                      .join("")}
                  </tr>
                `,
                  )
                  .join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    } else if (file == "excel") {
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }

      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility

      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]);
      csvContent += headers.join(",") + "\n";

      // Add Table Rows
      this.rows.forEach((row) => {
        const rowData = headers
          .map((header) => {
            let cell = row[header] ? row[header].toString() : "";
            return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, "")}"`; // Escape quotes & remove HTML
          })
          .join(",");
        csvContent += rowData + "\n";
      });

      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "Organizers-Check-In-And-Out.csv");
      document.body.appendChild(link);

      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }

  color: string = "#3F8260";
  save() {
    this.eventOrganizerCheckStatistics.markAllAsTouched();
    if (!this.eventOrganizerCheckStatistics.get("nameAr")?.value) {
      this.color = "#c72828";
      this.toastService.show("يرجى إدخال اسم الفئة بالعربية");
      return;
    }
    if (!this.eventOrganizerCheckStatistics.get("nameEn")?.value) {
      this.color = "#c72828";
      this.toastService.show("يرجى إدخال اسم الفئة بالانجليزية");
      return;
    }
    if (!this.eventOrganizerCheckStatistics.get("image")?.value) {
      this.color = "#c72828";
      this.toastService.show("يرجى تحميل صورة الغلاف والرأس");
      return;
    }
    if (this.eventOrganizerCheckStatistics.valid) {
      const formData = new FormData();
      formData.append(
        "NameAr",
        this.eventOrganizerCheckStatistics.get("nameAr")?.value,
      );
      formData.append(
        "NameEn",
        this.eventOrganizerCheckStatistics.get("nameEn")?.value,
      );
      formData.append(
        "ImageFile",
        this.eventOrganizerCheckStatistics.get("image")?.value,
      );

      this.api.addEventCategory(formData).subscribe({
        next: (response) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم الاضافة بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          // this.toastService.show(error.error.message + ' ❌');
          if (
            error.error.message ==
            "there is already existed category with same name"
          ) {
            this.toastService.show("الفئة موجودة بالفعل ❌");
          } else {
            this.toastService.show(
              "حدث خطأ أثناء الحفظ برجاء المحاولة مره اخري ❌",
            );
          }
        },
      });
    }
  }

  edit() {
    console.log(this.eventOrganizerCheckStatistics.value);
    if (this.eventOrganizerCheckStatistics.valid) {
      const formData = new FormData();
      formData.append(
        "NameAr",
        this.eventOrganizerCheckStatistics.get("nameAr")?.value,
      );
      formData.append(
        "NameEn",
        this.eventOrganizerCheckStatistics.get("nameEn")?.value,
      );
      formData.append("Id", this.idToEdit);
      formData.append(
        "ImageFile",
        this.eventOrganizerCheckStatistics.get("image")?.value,
      );

      this.api.editEventCategory(formData).subscribe({
        next: (response) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم التعديل بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show(
            "حدث خطأ أثناء الحفظ برجاء المحاولة مره اخري ❌",
          );
        },
      });
    }
  }

  reset() {
    this.eventOrganizerCheckStatistics.patchValue({
      id: "",
      nameAr: "",
      nameEn: "",
      image: "",
    });
    // console.log(this.eventOrganizerCheckStatistics.value)
  }

  dataToEdit: any;
  idToEdit: any;
  loadFormData(id: string) {
    if (id) {
      this.idToEdit = id;
      this.api.showEventCategory(id).subscribe({
        next: (response) => {
          this.dataToEdit = response.data;
          console.log(this.dataToEdit);
          this.eventOrganizerCheckStatistics.patchValue({
            id: this.dataToEdit.id,
            nameAr: this.dataToEdit.nameAr,
            nameEn: this.dataToEdit.nameEn,
            image: this.dataToEdit.image,
          });
          this.previewUrl2 = this.dataToEdit.image;
        },
        error: (error: HttpErrorResponse) => {},
      });
    }
  }

  arabicTextValidator(control: AbstractControl) {
    if (!control.value) return null; // skip validation if empty

    const arabicRegex =
      /^[\u0600-\u06FF\s\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/;
    return arabicRegex.test(control.value) ? null : { arabicOnly: true };
  }
  englishTextValidator(control: AbstractControl) {
    if (!control.value) return null;
    const englishRegex = /^[A-Za-z\s]+$/;
    return englishRegex.test(control.value) ? null : { englishOnly: true };
  }
}

